/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ old: NonNullable<unknown>, new: NonNullable<unknown> }} Partner_Activity_MemberInputs */



/**
* | output |
* | --- |
* | "Members {old} → {new}" |
*
* @param {Partner_Activity_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_member = /** @type {((inputs: Partner_Activity_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mitglieder ${i?.old} → ${i?.new}`)
	return /** @type {LocalizedString} */ (`Members ${i?.old} → ${i?.new}`)
});